import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import CohortPanelFull from '../containers/CohortPanelFull';
import CohortPanelNarrow from '../containers/CohortPanelNarrow';

const CohortPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: CohortPanelFull, narrow: CohortPanelNarrow }}
    onChange={onChange}
    width={800}
  />
);

export default CohortPanel;
